import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Heading from 'shopper/components/Heading';

import Anchor from 'components/Anchor';

import { getCategoryGroupedByGroupName } from 'lib/category';
import { toCategoryLink, toSubcategoryLink } from 'lib/links';

import SiteMapLinkItem from './LinkItem';
import SiteMapTitle from './Title';

const CategoriesList = ({ categories }) =>
  getCategoryGroupedByGroupName(categories).map(
    ({ categoryGroupId, categoryGroupName, categoriesWithSubcategories }) => (
      <div
        key={categoryGroupId}
        className="border-b border-neutral-high-400 pb-8 dark:border-neutral-low-300 md:pb-10"
      >
        <SiteMapTitle>{categoryGroupName}</SiteMapTitle>
        {categoriesWithSubcategories.map(
          ({ categoryName, categoryUrl, subcategories }) => (
            <div
              key={categoryUrl}
              className="flex flex-col items-start border-b border-neutral-high-400 pb-8 pt-8 first-of-type:pt-0 last-of-type:border-b-0 last-of-type:pb-0 dark:border-neutral-low-300 md:pb-10 md:pt-10 md:first-of-type:pt-0 md:last-of-type:pb-0"
            >
              <NextLink
                href={toCategoryLink(categoryUrl)}
                prefetch={false}
                passHref
              >
                <Anchor>
                  <Heading as="h3" className="mb-4" size="size6">
                    {categoryName}
                  </Heading>
                </Anchor>
              </NextLink>
              <div
                className="grid grid-flow-row grid-cols-2 items-start gap-x-4 gap-y-2 md:grid-flow-col md:grid-cols-4 md:grid-rows-[var(--custom-row-grid)] md:gap-y-4"
                style={{
                  '--custom-row-grid': `repeat(${Math.ceil(
                    subcategories.length / 4
                  )}, 1fr)`,
                }}
              >
                {subcategories.map(
                  ({ subcategoryId, subcategoryName, subcategoryParam }) => (
                    <SiteMapLinkItem
                      key={subcategoryId}
                      href={toSubcategoryLink(subcategoryParam)}
                    >
                      {subcategoryName}
                    </SiteMapLinkItem>
                  )
                )}
              </div>
            </div>
          )
        )}
      </div>
    )
  );

CategoriesList.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      categoryId: PropTypes.number,
      categoryName: PropTypes.string.isRequired,
      categoryUrl: PropTypes.string.isRequired,
      groupId: PropTypes.number.isRequired,
      groupName: PropTypes.string.isRequired,
      subcategories: PropTypes.arrayOf(
        PropTypes.shape({
          subcategoryId: PropTypes.number.isRequired,
          subcategoryName: PropTypes.string.isRequired,
          subcategoryParam: PropTypes.string.isRequired,
        })
      ),
    })
  ).isRequired,
};

export default CategoriesList;
